import React from "react";

import { useTranslation } from "react-i18next";

import useStyles from "./styles";

interface FooterProps {
  logo?: string;
}

export const Footer = (props: FooterProps) => {
  const { logo } = props;
  const { t: translate } = useTranslation();
  const classes = useStyles();

  const openShipeeziWeb = () => {
    window.open("https://www.shipeezi.com", "blank");
  };

  return (
    <section className={classes.footerSection}>
      <div className={classes.shipeeziLink} onClick={() => openShipeeziWeb()}>
        <span>{translate("poweredBy")}</span>
        <img src={logo} className="imageLogo" />
      </div>
    </section>
  );
};
